// TODO: to delete
import {combineReducers} from "redux";
import list from "./list";
import update from "./update";
import del from "./delete"
import delAll from "./deleteAll";
import markAllAsRead from "./markAllAsRead";

export default combineReducers({list, update, del, delAll, markAllAsRead});
